import React from "react"
import { Link } from "gatsby"
import "./RandomWarmupSelector.css"

const RandomWarmupSelector = ({ warmups }) => {
  return (
    <div className="RandomWarmupSelector-container" id="main-warmup-selector">
      <Link
        className="RandomWarmupSelector-button"
        to={`warmups/${warmups[Math.floor(Math.random() * warmups.length)].slug}`}
      >
        Warm Up!
      </Link>
    </div>
  )
}

export default RandomWarmupSelector
